var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorreo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00388 3.66797C1.8281 3.71485 1.65232 3.77344 1.60545 3.79688C1.54685 3.82617 3.43357 5.74805 8.2324 10.5469L14.9355 17.25L15.334 16.8984C15.5508 16.7109 18.6035 13.6934 22.1133 10.1895L28.4941 3.82617L28.207 3.71485C27.9258 3.60938 27.5449 3.60352 15.1172 3.5918C4.11912 3.58008 2.26756 3.5918 2.00388 3.66797Z",
    fill: "#0885C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 5.39648C0.0351562 5.70117 0.0292969 6.07617 0.0292969 15C0.0292969 23.9238 0.0351562 24.2988 0.140625 24.6035L0.246094 24.9199L5.20898 19.957L10.166 15L5.20898 10.043L0.246094 5.08008L0.140625 5.39648Z",
    fill: "#0885C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7852 10.0488L19.834 15L24.791 19.957L29.748 24.9141L29.8594 24.6328C29.9648 24.3574 29.9707 23.9941 29.9883 15.1758C30 6.01172 29.9941 5.69531 29.8066 5.25586C29.7363 5.09766 29.7363 5.09766 24.7852 10.0488Z",
    fill: "#0885C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45117 21.2344L1.50586 26.1797L1.82227 26.2852C2.12695 26.3906 2.58398 26.3965 15 26.3965C27.416 26.3965 27.873 26.3906 28.1777 26.2852L28.4941 26.1797L23.5488 21.2344C20.8301 18.5156 18.5859 16.2891 18.5684 16.2891C18.5449 16.2891 17.8652 16.9277 17.0508 17.707C16.2363 18.4922 15.4746 19.1895 15.3574 19.2598C15.0645 19.4414 14.7891 19.4297 14.4668 19.2246C14.3262 19.1309 13.5879 18.4336 12.832 17.6719C12.0762 16.9102 11.4434 16.2891 11.4258 16.2891C11.4082 16.2891 9.16992 18.5156 6.45117 21.2344Z",
    fill: "#0885C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo);
export default __webpack_public_path__ + "static/media/correo.9c8ce78cf5de7cb3d3521b9d9fdcc3bd.svg";
export { ForwardRef as ReactComponent };